export default __webpack_public_path__ + "static/media/monk.91886cc2.webp";